import React__default from 'react';
import { BaseButton } from '../LegacyButton/BaseButton.es.js';

const ButtonNavButton = (props) => {
  return React__default.createElement(BaseButton, Object.assign({}, props, { size: "small" }));
};

export { ButtonNavButton };
//# sourceMappingURL=ButtonNavButton.es.js.map
